import { useContext } from 'react';
import type { SpLogicCheckSignApi } from '@sp-api/check-sign-api';
import ApiContext from '../components/ApiProvider/ApiContext';

export default function useCheckSignApiClient(): SpLogicCheckSignApi {
  const { checkSignApi } = useContext(ApiContext);
  return checkSignApi;
}
